export default {"src":"/_next/static/media/contact_page.2bd709ac.svg","height":3840,"width":3840};